<template>
  <div class="base-form-div">
    <el-form
      size="mini"
      :label-position="labelPosition"
      label-width="80px"
      :model="formSet"
    >
      <el-form-item label="名称">
        <el-input v-model="name"></el-input>
      </el-form-item>

      <el-form-item label="线型">
        <el-select
          @change="changeMaterialType"
          v-model="formSet.materialType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in optionsType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="线宽">
        <el-input-number
          v-model="formSet.width"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>

      <el-form-item v-show="formSet.materialType == 'ColorMaterialProperty'" label="颜色">
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.color"
        ></el-color-picker>
      </el-form-item>

      <el-form-item
        v-show="formSet.materialType == 'PolylineOutlineMaterialProperty'"
        label="主色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.color"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'PolylineOutlineMaterialProperty'"
        label="衬色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.outlineColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'PolylineOutlineMaterialProperty'"
        label="衬色宽度"
      >
        <el-input-number
          v-model="formSet.materialOption.outlineWidth"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>

      <el-form-item
        v-show="formSet.materialType == 'PolylineDashMaterialProperty'"
        label="主色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.color"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'PolylineDashMaterialProperty'"
        label="间隔颜色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.gapColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'PolylineDashMaterialProperty'"
        label="间隔长度"
      >
        <el-input-number
          v-model="formSet.materialOption.dashLength"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>

      <el-form-item
        v-show="formSet.materialType == 'PolylineArrowMaterialProperty'"
        label="颜色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.color"
        ></el-color-picker>
      </el-form-item>

      <el-form-item
        v-show="formSet.materialType == 'PolylineGlowMaterialProperty'"
        label="颜色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.color"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'PolylineGlowMaterialProperty'"
        label="光辉强度"
      >
        <el-input-number
          v-model="formSet.materialOption.glowPower"
          :step="0.1"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'PolylineGlowMaterialProperty'"
        label="渐变"
      >
        <el-input-number
          v-model="formSet.materialOption.taperPower"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>

      <el-form-item
        v-show="formSet.materialType == 'SatelliteMaterialProperty'"
        label="颜色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.color"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'SatelliteMaterialProperty'"
        label="背景色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.backgroundColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'SatelliteMaterialProperty'"
        label="速度"
      >
        <el-input-number
          v-model="formSet.materialOption.speed"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'SatelliteMaterialProperty'"
        label="梯度"
      >
        <el-input-number
          v-model="formSet.materialOption.gradient"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'SatelliteMaterialProperty'"
        label="数量"
      >
        <el-input-number
          v-model="formSet.materialOption.count"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="显示层级">
        <el-input-number
          v-model="formSet.zIndex"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="是否贴地">
        <el-switch
          v-model="formSet.clampToGround"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <div class="form-bottom">
      <el-button class="base-button" size="mini" type="primary" @click="savePlot"
        >保存</el-button
      >
      <!-- <el-button class="base-button" size="mini" type="primary" @click="exportPlot">导出</el-button> -->
      <el-button class="base-button" size="mini" type="primary" @click="deletePlot"
        >删除</el-button
      >
    </div>
  </div>
</template>

<script>
import { createMark, deleteByMarkId } from "@/api/vectorPlot/index.js";
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js";
import * as Help from "@/components/PlanEditor/Actions/help.js";
let entity;
export default {
  props: ["subData"],
  data() {
    return {
      predefineColors: ["#ff0000", "#0000ff", "#00ff00", "#00ffff"],
      optionsType: StyleUtil.getLineTypes(),
      labelPosition: "left",
      formSet: {
        materialType: "ColorMaterialProperty",
        materialOption: {
          color: "",
        },
        zIndex: 0,
      },
      name: "线",
    };
  },

  watch: {
    formSet: {
      // 数据变化时执行的逻辑代码
      handler(newObj, oldObj) {
        StyleUtil.setStyle2Entity(newObj, entity, "polyline");
      },
      // 开启深度监听
      deep: true,
    },
  },

  mounted() {
    if (typeof this.subData == "function") {
      entity = this.subData();
    } else {
      entity = this.subData.entity;
    }
    this.name = entity.markName || entity.typeName;
    //回显
    if (entity["polyline"]["attr"] && entity["polyline"]["attr"].materialType) {
      this.formSet.materialType = entity["polyline"]["attr"].materialType;
    }
    this.changeMaterialType();
    console.log(entity);
  },

  methods: {
    changeMaterialType() {
      let style = StyleUtil.getEntity2Style(this.formSet, entity, "polyline");
      this.formSet = style;
    },
    savePlot() {
      StyleUtil.setStyle2Entity(this.formSet, entity, "polyline");
      let data = {
        extType: entity.typeName,
        editPositions: JSON.stringify(entity.attrPlot.edit_positions),
        styleAttr: JSON.stringify(entity["polyline"]["attr"]),
        postureAttr: "",
        userId: 111,
        markId: entity.id,
        markName: this.name,
      };

      console.log(data);
      let action = {};
      action.name = this.name;
      action.type = "commonPlot";
      action.typeName = "常用标绘";
      action.delay = 1;
      action.data = data;
      if (entity.isAlreadyPlotflag) {
        entity.markName = this.name;
        entity.update(action);
        this.$parent.close();
        return;
      }
      if (typeof this.subData != "function") {
        this.subData.update(action);
        this.$parent.close();
        return;
      }
      if (entity.isPlotflag) {
        entity.isPlotflag = false;
        entity.markName = this.name;
        this.$bus.$emit("addActionObj", action);
        Help.addEntityArr(entity);
        this.$parent.close();
        return;
      }

      createMark(data)
        .then((res) => {
          this.$message({
            showClose: true,
            message: "保存成功,请到我的标绘中进行查看！",
            type: "success",
            duration: 3 * 1000,
          });
          this.$bus.$emit("vectorPlot-list");

          entity.markName = data.markName;
        })
        .catch((err) => {
          console.err(err);
        });
    },
    exportPlot() {},
    deletePlot() {
      if (entity.isPlotflag) {
        StyleUtil.deletePlot(entity);
        this.$parent.close();
        return;
      }
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteByMarkId(entity.id).then((res) => {
            console.log(res);
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("vectorPlot-list");
            StyleUtil.deletePlot(entity);
            this.$parent.close();
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.base-form-div {
  padding: 20px;
}

.form-bottom {
  text-align: center;
  border-top: 1px solid rgba(153, 153, 153, 0.5);
  padding-top: 20px;
}
</style>
